/* tslint:disable */
/* eslint-disable */
/**
 * Docket APIs
 * An OpenAPI model for the Docket API\'s that are written in Typescript
 *
 * The version of the OpenAPI document: 1.0.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from './base';
export const ForecastWithEventsDtoStatusEnum = {
    DueNow: 'DUE_NOW',
    Overdue: 'OVERDUE',
    Complete: 'COMPLETE',
    Current: 'CURRENT',
    Unknown: 'UNKNOWN'
};
export const ManifestFileContentTypeEnum = {
    ApplicationSmartHealthCard: 'application/smart-health-card'
};
export const PatientDtoLegalSexEnum = {
    M: 'M',
    F: 'F',
    X: 'X',
    U: 'U'
};
export const SHLinkDescriptionDtoStatusEnum = {
    Active: 'active',
    Inactive: 'inactive'
};
export const ScreeningDtoTypeEnum = {
    Lead: 'BLOOD_LEAD',
    LeadCapillary: 'BLOOD_LEAD_CAPILLARY',
    LeadVenous: 'BLOOD_LEAD_VENOUS'
};
export const TelecommunicationDtoMethodEnum = {
    Email: 'EMAIL',
    Phone: 'PHONE',
    Unknown: 'UNKNOWN'
};
export const VaccineCodeCptDtoSystemEnum = {
    Cpt: 'cpt',
    C4: 'c4'
};
export const VaccineCodeCvxDtoSystemEnum = {
    Cvx: 'cvx'
};
/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
export const AuthenticationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {AppleLoginRequestDto} appleLoginRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apple: (appleLoginRequestDto_1, xUserAgent_1, ...args_1) => __awaiter(this, [appleLoginRequestDto_1, xUserAgent_1, ...args_1], void 0, function* (appleLoginRequestDto, xUserAgent, options = {}) {
            // verify required parameter 'appleLoginRequestDto' is not null or undefined
            assertParamExists('apple', 'appleLoginRequestDto', appleLoginRequestDto);
            const localVarPath = `/api/user/apple_auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(appleLoginRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {FirebaseLoginRequestDto} firebaseLoginRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        firebase: (firebaseLoginRequestDto_1, xUserAgent_1, ...args_1) => __awaiter(this, [firebaseLoginRequestDto_1, xUserAgent_1, ...args_1], void 0, function* (firebaseLoginRequestDto, xUserAgent, options = {}) {
            // verify required parameter 'firebaseLoginRequestDto' is not null or undefined
            assertParamExists('firebase', 'firebaseLoginRequestDto', firebaseLoginRequestDto);
            const localVarPath = `/api/user/firebase_auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(firebaseLoginRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {GoogleLoginRequestDto} googleLoginRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        google: (googleLoginRequestDto_1, xUserAgent_1, ...args_1) => __awaiter(this, [googleLoginRequestDto_1, xUserAgent_1, ...args_1], void 0, function* (googleLoginRequestDto, xUserAgent, options = {}) {
            // verify required parameter 'googleLoginRequestDto' is not null or undefined
            assertParamExists('google', 'googleLoginRequestDto', googleLoginRequestDto);
            const localVarPath = `/api/user/google_auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(googleLoginRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {BasicAuthRequestDto} basicAuthRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: (basicAuthRequestDto_1, xUserAgent_1, ...args_1) => __awaiter(this, [basicAuthRequestDto_1, xUserAgent_1, ...args_1], void 0, function* (basicAuthRequestDto, xUserAgent, options = {}) {
            // verify required parameter 'basicAuthRequestDto' is not null or undefined
            assertParamExists('login', 'basicAuthRequestDto', basicAuthRequestDto);
            const localVarPath = `/api/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(basicAuthRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {IntegTestLoginRequestDto} integTestLoginRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginIntegTest: (integTestLoginRequestDto_1, xUserAgent_1, ...args_1) => __awaiter(this, [integTestLoginRequestDto_1, xUserAgent_1, ...args_1], void 0, function* (integTestLoginRequestDto, xUserAgent, options = {}) {
            // verify required parameter 'integTestLoginRequestDto' is not null or undefined
            assertParamExists('loginIntegTest', 'integTestLoginRequestDto', integTestLoginRequestDto);
            const localVarPath = `/api/auth/integ-test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication machine-to-machine required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(integTestLoginRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} oidcJurisdiction
         * @param {AuthorizationCodeDto} authorizationCodeDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oidc: (oidcJurisdiction_1, authorizationCodeDto_1, xUserAgent_1, ...args_1) => __awaiter(this, [oidcJurisdiction_1, authorizationCodeDto_1, xUserAgent_1, ...args_1], void 0, function* (oidcJurisdiction, authorizationCodeDto, xUserAgent, options = {}) {
            // verify required parameter 'oidcJurisdiction' is not null or undefined
            assertParamExists('oidc', 'oidcJurisdiction', oidcJurisdiction);
            // verify required parameter 'authorizationCodeDto' is not null or undefined
            assertParamExists('oidc', 'authorizationCodeDto', authorizationCodeDto);
            const localVarPath = `/auth/{oidcJurisdiction}`
                .replace(`{${"oidcJurisdiction"}}`, encodeURIComponent(String(oidcJurisdiction)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(authorizationCodeDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} oidcJurisdiction
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oidcAuthorizeRedirect: (oidcJurisdiction_1, xUserAgent_1, ...args_1) => __awaiter(this, [oidcJurisdiction_1, xUserAgent_1, ...args_1], void 0, function* (oidcJurisdiction, xUserAgent, options = {}) {
            // verify required parameter 'oidcJurisdiction' is not null or undefined
            assertParamExists('oidcAuthorizeRedirect', 'oidcJurisdiction', oidcJurisdiction);
            const localVarPath = `/auth/{oidcJurisdiction}`
                .replace(`{${"oidcJurisdiction"}}`, encodeURIComponent(String(oidcJurisdiction)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} state
         * @param {string} code
         * @param {string} oidcJurisdiction
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oidcCallbackRedirect: (state_1, code_1, oidcJurisdiction_1, xUserAgent_1, ...args_1) => __awaiter(this, [state_1, code_1, oidcJurisdiction_1, xUserAgent_1, ...args_1], void 0, function* (state, code, oidcJurisdiction, xUserAgent, options = {}) {
            // verify required parameter 'state' is not null or undefined
            assertParamExists('oidcCallbackRedirect', 'state', state);
            // verify required parameter 'code' is not null or undefined
            assertParamExists('oidcCallbackRedirect', 'code', code);
            // verify required parameter 'oidcJurisdiction' is not null or undefined
            assertParamExists('oidcCallbackRedirect', 'oidcJurisdiction', oidcJurisdiction);
            const localVarPath = `/auth/{oidcJurisdiction}/callback`
                .replace(`{${"oidcJurisdiction"}}`, encodeURIComponent(String(oidcJurisdiction)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }
            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {RefreshTokensRequestDto} refreshTokensRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshTokens: (refreshTokensRequestDto_1, xUserAgent_1, ...args_1) => __awaiter(this, [refreshTokensRequestDto_1, xUserAgent_1, ...args_1], void 0, function* (refreshTokensRequestDto, xUserAgent, options = {}) {
            // verify required parameter 'refreshTokensRequestDto' is not null or undefined
            assertParamExists('refreshTokens', 'refreshTokensRequestDto', refreshTokensRequestDto);
            const localVarPath = `/api/auth/tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(refreshTokensRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {RefreshTokensRequestDto} refreshTokensRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRefreshTokenFamily: (refreshTokensRequestDto_1, xUserAgent_1, ...args_1) => __awaiter(this, [refreshTokensRequestDto_1, xUserAgent_1, ...args_1], void 0, function* (refreshTokensRequestDto, xUserAgent, options = {}) {
            // verify required parameter 'refreshTokensRequestDto' is not null or undefined
            assertParamExists('removeRefreshTokenFamily', 'refreshTokensRequestDto', refreshTokensRequestDto);
            const localVarPath = `/api/auth/tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(refreshTokensRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SendMagicLinkRequestDto} sendMagicLinkRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMagicLink: (sendMagicLinkRequestDto_1, xUserAgent_1, ...args_1) => __awaiter(this, [sendMagicLinkRequestDto_1, xUserAgent_1, ...args_1], void 0, function* (sendMagicLinkRequestDto, xUserAgent, options = {}) {
            // verify required parameter 'sendMagicLinkRequestDto' is not null or undefined
            assertParamExists('sendMagicLink', 'sendMagicLinkRequestDto', sendMagicLinkRequestDto);
            const localVarPath = `/api/auth/magic_link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(sendMagicLinkRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AuthenticationApi - functional programming interface
 * @export
 */
export const AuthenticationApiFp = function (configuration) {
    const localVarAxiosParamCreator = AuthenticationApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {AppleLoginRequestDto} appleLoginRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apple(appleLoginRequestDto, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apple(appleLoginRequestDto, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AuthenticationApi.apple']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {FirebaseLoginRequestDto} firebaseLoginRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        firebase(firebaseLoginRequestDto, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.firebase(firebaseLoginRequestDto, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AuthenticationApi.firebase']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {GoogleLoginRequestDto} googleLoginRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        google(googleLoginRequestDto, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.google(googleLoginRequestDto, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AuthenticationApi.google']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {BasicAuthRequestDto} basicAuthRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(basicAuthRequestDto, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.login(basicAuthRequestDto, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AuthenticationApi.login']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {IntegTestLoginRequestDto} integTestLoginRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginIntegTest(integTestLoginRequestDto, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.loginIntegTest(integTestLoginRequestDto, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AuthenticationApi.loginIntegTest']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} oidcJurisdiction
         * @param {AuthorizationCodeDto} authorizationCodeDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oidc(oidcJurisdiction, authorizationCodeDto, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.oidc(oidcJurisdiction, authorizationCodeDto, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AuthenticationApi.oidc']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} oidcJurisdiction
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oidcAuthorizeRedirect(oidcJurisdiction, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.oidcAuthorizeRedirect(oidcJurisdiction, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AuthenticationApi.oidcAuthorizeRedirect']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} state
         * @param {string} code
         * @param {string} oidcJurisdiction
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oidcCallbackRedirect(state, code, oidcJurisdiction, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.oidcCallbackRedirect(state, code, oidcJurisdiction, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AuthenticationApi.oidcCallbackRedirect']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {RefreshTokensRequestDto} refreshTokensRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshTokens(refreshTokensRequestDto, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.refreshTokens(refreshTokensRequestDto, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AuthenticationApi.refreshTokens']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {RefreshTokensRequestDto} refreshTokensRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRefreshTokenFamily(refreshTokensRequestDto, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.removeRefreshTokenFamily(refreshTokensRequestDto, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AuthenticationApi.removeRefreshTokenFamily']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SendMagicLinkRequestDto} sendMagicLinkRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMagicLink(sendMagicLinkRequestDto, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sendMagicLink(sendMagicLinkRequestDto, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AuthenticationApi.sendMagicLink']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * AuthenticationApi - factory interface
 * @export
 */
export const AuthenticationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AuthenticationApiFp(configuration);
    return {
        /**
         *
         * @param {AppleLoginRequestDto} appleLoginRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apple(appleLoginRequestDto, xUserAgent, options) {
            return localVarFp.apple(appleLoginRequestDto, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {FirebaseLoginRequestDto} firebaseLoginRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        firebase(firebaseLoginRequestDto, xUserAgent, options) {
            return localVarFp.firebase(firebaseLoginRequestDto, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {GoogleLoginRequestDto} googleLoginRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        google(googleLoginRequestDto, xUserAgent, options) {
            return localVarFp.google(googleLoginRequestDto, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {BasicAuthRequestDto} basicAuthRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(basicAuthRequestDto, xUserAgent, options) {
            return localVarFp.login(basicAuthRequestDto, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {IntegTestLoginRequestDto} integTestLoginRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginIntegTest(integTestLoginRequestDto, xUserAgent, options) {
            return localVarFp.loginIntegTest(integTestLoginRequestDto, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} oidcJurisdiction
         * @param {AuthorizationCodeDto} authorizationCodeDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oidc(oidcJurisdiction, authorizationCodeDto, xUserAgent, options) {
            return localVarFp.oidc(oidcJurisdiction, authorizationCodeDto, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} oidcJurisdiction
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oidcAuthorizeRedirect(oidcJurisdiction, xUserAgent, options) {
            return localVarFp.oidcAuthorizeRedirect(oidcJurisdiction, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} state
         * @param {string} code
         * @param {string} oidcJurisdiction
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oidcCallbackRedirect(state, code, oidcJurisdiction, xUserAgent, options) {
            return localVarFp.oidcCallbackRedirect(state, code, oidcJurisdiction, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {RefreshTokensRequestDto} refreshTokensRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshTokens(refreshTokensRequestDto, xUserAgent, options) {
            return localVarFp.refreshTokens(refreshTokensRequestDto, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {RefreshTokensRequestDto} refreshTokensRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRefreshTokenFamily(refreshTokensRequestDto, xUserAgent, options) {
            return localVarFp.removeRefreshTokenFamily(refreshTokensRequestDto, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SendMagicLinkRequestDto} sendMagicLinkRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMagicLink(sendMagicLinkRequestDto, xUserAgent, options) {
            return localVarFp.sendMagicLink(sendMagicLinkRequestDto, xUserAgent, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
export class AuthenticationApi extends BaseAPI {
    /**
     *
     * @param {AppleLoginRequestDto} appleLoginRequestDto
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    apple(appleLoginRequestDto, xUserAgent, options) {
        return AuthenticationApiFp(this.configuration).apple(appleLoginRequestDto, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {FirebaseLoginRequestDto} firebaseLoginRequestDto
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    firebase(firebaseLoginRequestDto, xUserAgent, options) {
        return AuthenticationApiFp(this.configuration).firebase(firebaseLoginRequestDto, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {GoogleLoginRequestDto} googleLoginRequestDto
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    google(googleLoginRequestDto, xUserAgent, options) {
        return AuthenticationApiFp(this.configuration).google(googleLoginRequestDto, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BasicAuthRequestDto} basicAuthRequestDto
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    login(basicAuthRequestDto, xUserAgent, options) {
        return AuthenticationApiFp(this.configuration).login(basicAuthRequestDto, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {IntegTestLoginRequestDto} integTestLoginRequestDto
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    loginIntegTest(integTestLoginRequestDto, xUserAgent, options) {
        return AuthenticationApiFp(this.configuration).loginIntegTest(integTestLoginRequestDto, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} oidcJurisdiction
     * @param {AuthorizationCodeDto} authorizationCodeDto
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    oidc(oidcJurisdiction, authorizationCodeDto, xUserAgent, options) {
        return AuthenticationApiFp(this.configuration).oidc(oidcJurisdiction, authorizationCodeDto, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} oidcJurisdiction
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    oidcAuthorizeRedirect(oidcJurisdiction, xUserAgent, options) {
        return AuthenticationApiFp(this.configuration).oidcAuthorizeRedirect(oidcJurisdiction, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} state
     * @param {string} code
     * @param {string} oidcJurisdiction
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    oidcCallbackRedirect(state, code, oidcJurisdiction, xUserAgent, options) {
        return AuthenticationApiFp(this.configuration).oidcCallbackRedirect(state, code, oidcJurisdiction, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {RefreshTokensRequestDto} refreshTokensRequestDto
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    refreshTokens(refreshTokensRequestDto, xUserAgent, options) {
        return AuthenticationApiFp(this.configuration).refreshTokens(refreshTokensRequestDto, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {RefreshTokensRequestDto} refreshTokensRequestDto
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    removeRefreshTokenFamily(refreshTokensRequestDto, xUserAgent, options) {
        return AuthenticationApiFp(this.configuration).removeRefreshTokenFamily(refreshTokensRequestDto, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SendMagicLinkRequestDto} sendMagicLinkRequestDto
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    sendMagicLink(sendMagicLinkRequestDto, xUserAgent, options) {
        return AuthenticationApiFp(this.configuration).sendMagicLink(sendMagicLinkRequestDto, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * HL7Api - axios parameter creator
 * @export
 */
export const HL7ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {IceEvaluationInput} iceEvaluationInput
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iceEvaluation: (iceEvaluationInput_1, xUserAgent_1, ...args_1) => __awaiter(this, [iceEvaluationInput_1, xUserAgent_1, ...args_1], void 0, function* (iceEvaluationInput, xUserAgent, options = {}) {
            // verify required parameter 'iceEvaluationInput' is not null or undefined
            assertParamExists('iceEvaluation', 'iceEvaluationInput', iceEvaluationInput);
            const localVarPath = `/api/hl7/v1/ice-evaluation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication machine-to-machine required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(iceEvaluationInput, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ParseZ34ResponseInput} parseZ34ResponseInput
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parseZ34Response: (parseZ34ResponseInput_1, xUserAgent_1, ...args_1) => __awaiter(this, [parseZ34ResponseInput_1, xUserAgent_1, ...args_1], void 0, function* (parseZ34ResponseInput, xUserAgent, options = {}) {
            // verify required parameter 'parseZ34ResponseInput' is not null or undefined
            assertParamExists('parseZ34Response', 'parseZ34ResponseInput', parseZ34ResponseInput);
            const localVarPath = `/api/hl7/v1/z34`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication machine-to-machine required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(parseZ34ResponseInput, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ParseZ44ResponseInput} parseZ44ResponseInput
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parseZ44Response: (parseZ44ResponseInput_1, xUserAgent_1, ...args_1) => __awaiter(this, [parseZ44ResponseInput_1, xUserAgent_1, ...args_1], void 0, function* (parseZ44ResponseInput, xUserAgent, options = {}) {
            // verify required parameter 'parseZ44ResponseInput' is not null or undefined
            assertParamExists('parseZ44Response', 'parseZ44ResponseInput', parseZ44ResponseInput);
            const localVarPath = `/api/hl7/v1/z44`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication machine-to-machine required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(parseZ44ResponseInput, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ParseZ44ResponseInput} parseZ44ResponseInput
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parseZ44ResponseRailsLegacy: (parseZ44ResponseInput_1, xUserAgent_1, ...args_1) => __awaiter(this, [parseZ44ResponseInput_1, xUserAgent_1, ...args_1], void 0, function* (parseZ44ResponseInput, xUserAgent, options = {}) {
            // verify required parameter 'parseZ44ResponseInput' is not null or undefined
            assertParamExists('parseZ44ResponseRailsLegacy', 'parseZ44ResponseInput', parseZ44ResponseInput);
            const localVarPath = `/api/hl7/v1/z44-rails-legacy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication machine-to-machine required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(parseZ44ResponseInput, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * HL7Api - functional programming interface
 * @export
 */
export const HL7ApiFp = function (configuration) {
    const localVarAxiosParamCreator = HL7ApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {IceEvaluationInput} iceEvaluationInput
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iceEvaluation(iceEvaluationInput, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.iceEvaluation(iceEvaluationInput, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['HL7Api.iceEvaluation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {ParseZ34ResponseInput} parseZ34ResponseInput
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parseZ34Response(parseZ34ResponseInput, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.parseZ34Response(parseZ34ResponseInput, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['HL7Api.parseZ34Response']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {ParseZ44ResponseInput} parseZ44ResponseInput
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parseZ44Response(parseZ44ResponseInput, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.parseZ44Response(parseZ44ResponseInput, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['HL7Api.parseZ44Response']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {ParseZ44ResponseInput} parseZ44ResponseInput
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parseZ44ResponseRailsLegacy(parseZ44ResponseInput, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.parseZ44ResponseRailsLegacy(parseZ44ResponseInput, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['HL7Api.parseZ44ResponseRailsLegacy']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * HL7Api - factory interface
 * @export
 */
export const HL7ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = HL7ApiFp(configuration);
    return {
        /**
         *
         * @param {IceEvaluationInput} iceEvaluationInput
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iceEvaluation(iceEvaluationInput, xUserAgent, options) {
            return localVarFp.iceEvaluation(iceEvaluationInput, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ParseZ34ResponseInput} parseZ34ResponseInput
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parseZ34Response(parseZ34ResponseInput, xUserAgent, options) {
            return localVarFp.parseZ34Response(parseZ34ResponseInput, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ParseZ44ResponseInput} parseZ44ResponseInput
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parseZ44Response(parseZ44ResponseInput, xUserAgent, options) {
            return localVarFp.parseZ44Response(parseZ44ResponseInput, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ParseZ44ResponseInput} parseZ44ResponseInput
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parseZ44ResponseRailsLegacy(parseZ44ResponseInput, xUserAgent, options) {
            return localVarFp.parseZ44ResponseRailsLegacy(parseZ44ResponseInput, xUserAgent, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * HL7Api - object-oriented interface
 * @export
 * @class HL7Api
 * @extends {BaseAPI}
 */
export class HL7Api extends BaseAPI {
    /**
     *
     * @param {IceEvaluationInput} iceEvaluationInput
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HL7Api
     */
    iceEvaluation(iceEvaluationInput, xUserAgent, options) {
        return HL7ApiFp(this.configuration).iceEvaluation(iceEvaluationInput, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ParseZ34ResponseInput} parseZ34ResponseInput
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HL7Api
     */
    parseZ34Response(parseZ34ResponseInput, xUserAgent, options) {
        return HL7ApiFp(this.configuration).parseZ34Response(parseZ34ResponseInput, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ParseZ44ResponseInput} parseZ44ResponseInput
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HL7Api
     */
    parseZ44Response(parseZ44ResponseInput, xUserAgent, options) {
        return HL7ApiFp(this.configuration).parseZ44Response(parseZ44ResponseInput, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ParseZ44ResponseInput} parseZ44ResponseInput
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HL7Api
     */
    parseZ44ResponseRailsLegacy(parseZ44ResponseInput, xUserAgent, options) {
        return HL7ApiFp(this.configuration).parseZ44ResponseRailsLegacy(parseZ44ResponseInput, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * MiscellaneousRoutesApi - axios parameter creator
 * @export
 */
export const MiscellaneousRoutesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appleAppSiteAssociation: (xUserAgent_1, ...args_1) => __awaiter(this, [xUserAgent_1, ...args_1], void 0, function* (xUserAgent, options = {}) {
            const localVarPath = `/.well-known/apple-app-site-association`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetLinks: (xUserAgent_1, ...args_1) => __awaiter(this, [xUserAgent_1, ...args_1], void 0, function* (xUserAgent, options = {}) {
            const localVarPath = `/.well-known/assetlinks.json`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHello: (xUserAgent_1, ...args_1) => __awaiter(this, [xUserAgent_1, ...args_1], void 0, function* (xUserAgent, options = {}) {
            const localVarPath = `/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * MiscellaneousRoutesApi - functional programming interface
 * @export
 */
export const MiscellaneousRoutesApiFp = function (configuration) {
    const localVarAxiosParamCreator = MiscellaneousRoutesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appleAppSiteAssociation(xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.appleAppSiteAssociation(xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['MiscellaneousRoutesApi.appleAppSiteAssociation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetLinks(xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.assetLinks(xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['MiscellaneousRoutesApi.assetLinks']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHello(xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getHello(xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['MiscellaneousRoutesApi.getHello']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * MiscellaneousRoutesApi - factory interface
 * @export
 */
export const MiscellaneousRoutesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MiscellaneousRoutesApiFp(configuration);
    return {
        /**
         *
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appleAppSiteAssociation(xUserAgent, options) {
            return localVarFp.appleAppSiteAssociation(xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetLinks(xUserAgent, options) {
            return localVarFp.assetLinks(xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHello(xUserAgent, options) {
            return localVarFp.getHello(xUserAgent, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MiscellaneousRoutesApi - object-oriented interface
 * @export
 * @class MiscellaneousRoutesApi
 * @extends {BaseAPI}
 */
export class MiscellaneousRoutesApi extends BaseAPI {
    /**
     *
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MiscellaneousRoutesApi
     */
    appleAppSiteAssociation(xUserAgent, options) {
        return MiscellaneousRoutesApiFp(this.configuration).appleAppSiteAssociation(xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MiscellaneousRoutesApi
     */
    assetLinks(xUserAgent, options) {
        return MiscellaneousRoutesApiFp(this.configuration).assetLinks(xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MiscellaneousRoutesApi
     */
    getHello(xUserAgent, options) {
        return MiscellaneousRoutesApiFp(this.configuration).getHello(xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * RailsLegacyV2Api - axios parameter creator
 * @export
 */
export const RailsLegacyV2ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {LegacyCreateDeviceRequestDto} legacyCreateDeviceRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDevice: (legacyCreateDeviceRequestDto_1, xUserAgent_1, ...args_1) => __awaiter(this, [legacyCreateDeviceRequestDto_1, xUserAgent_1, ...args_1], void 0, function* (legacyCreateDeviceRequestDto, xUserAgent, options = {}) {
            // verify required parameter 'legacyCreateDeviceRequestDto' is not null or undefined
            assertParamExists('createDevice', 'legacyCreateDeviceRequestDto', legacyCreateDeviceRequestDto);
            const localVarPath = `/api/v2/device`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyToken required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-token", configuration);
            // authentication apiKeyEmail required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-email", configuration);
            // authentication docket-user required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(legacyCreateDeviceRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} deviceId
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDevice: (deviceId_1, xUserAgent_1, ...args_1) => __awaiter(this, [deviceId_1, xUserAgent_1, ...args_1], void 0, function* (deviceId, xUserAgent, options = {}) {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('deleteDevice', 'deviceId', deviceId);
            const localVarPath = `/api/v2/device/{deviceId}`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyToken required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-token", configuration);
            // authentication apiKeyEmail required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-email", configuration);
            // authentication docket-user required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} searchUid
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRecord: (jurisdictionId_1, searchUid_1, xUserAgent_1, ...args_1) => __awaiter(this, [jurisdictionId_1, searchUid_1, xUserAgent_1, ...args_1], void 0, function* (jurisdictionId, searchUid, xUserAgent, options = {}) {
            // verify required parameter 'jurisdictionId' is not null or undefined
            assertParamExists('deleteRecord', 'jurisdictionId', jurisdictionId);
            // verify required parameter 'searchUid' is not null or undefined
            assertParamExists('deleteRecord', 'searchUid', searchUid);
            const localVarPath = `/api/v2/immunizations/jurisdictions/{jurisdictionId}/records/{searchUid}`
                .replace(`{${"jurisdictionId"}}`, encodeURIComponent(String(jurisdictionId)))
                .replace(`{${"searchUid"}}`, encodeURIComponent(String(searchUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyToken required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-token", configuration);
            // authentication apiKeyEmail required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-email", configuration);
            // authentication docket-user required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} searchUid
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSearch: (jurisdictionId_1, searchUid_1, xUserAgent_1, ...args_1) => __awaiter(this, [jurisdictionId_1, searchUid_1, xUserAgent_1, ...args_1], void 0, function* (jurisdictionId, searchUid, xUserAgent, options = {}) {
            // verify required parameter 'jurisdictionId' is not null or undefined
            assertParamExists('deleteSearch', 'jurisdictionId', jurisdictionId);
            // verify required parameter 'searchUid' is not null or undefined
            assertParamExists('deleteSearch', 'searchUid', searchUid);
            const localVarPath = `/api/v2/immunizations/jurisdictions/{jurisdictionId}/search/{searchUid}`
                .replace(`{${"jurisdictionId"}}`, encodeURIComponent(String(jurisdictionId)))
                .replace(`{${"searchUid"}}`, encodeURIComponent(String(searchUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyToken required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-token", configuration);
            // authentication apiKeyEmail required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-email", configuration);
            // authentication docket-user required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: (xUserAgent_1, ...args_1) => __awaiter(this, [xUserAgent_1, ...args_1], void 0, function* (xUserAgent, options = {}) {
            const localVarPath = `/api/v2/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyToken required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-token", configuration);
            // authentication apiKeyEmail required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-email", configuration);
            // authentication docket-user required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} searchUid
         * @param {LegacyDeliverSearchPinRequestDto} legacyDeliverSearchPinRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliverSearchPin: (jurisdictionId_1, searchUid_1, legacyDeliverSearchPinRequestDto_1, xUserAgent_1, ...args_1) => __awaiter(this, [jurisdictionId_1, searchUid_1, legacyDeliverSearchPinRequestDto_1, xUserAgent_1, ...args_1], void 0, function* (jurisdictionId, searchUid, legacyDeliverSearchPinRequestDto, xUserAgent, options = {}) {
            // verify required parameter 'jurisdictionId' is not null or undefined
            assertParamExists('deliverSearchPin', 'jurisdictionId', jurisdictionId);
            // verify required parameter 'searchUid' is not null or undefined
            assertParamExists('deliverSearchPin', 'searchUid', searchUid);
            // verify required parameter 'legacyDeliverSearchPinRequestDto' is not null or undefined
            assertParamExists('deliverSearchPin', 'legacyDeliverSearchPinRequestDto', legacyDeliverSearchPinRequestDto);
            const localVarPath = `/api/v2/immunizations/jurisdictions/{jurisdictionId}/deliver_pin/{searchUid}`
                .replace(`{${"jurisdictionId"}}`, encodeURIComponent(String(jurisdictionId)))
                .replace(`{${"searchUid"}}`, encodeURIComponent(String(searchUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyToken required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-token", configuration);
            // authentication apiKeyEmail required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-email", configuration);
            // authentication docket-user required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(legacyDeliverSearchPinRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} jurisdictionId
         * @param {LegacyEnqueueSearchRequestDto} legacyEnqueueSearchRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enqueueSearch: (jurisdictionId_1, legacyEnqueueSearchRequestDto_1, xUserAgent_1, ...args_1) => __awaiter(this, [jurisdictionId_1, legacyEnqueueSearchRequestDto_1, xUserAgent_1, ...args_1], void 0, function* (jurisdictionId, legacyEnqueueSearchRequestDto, xUserAgent, options = {}) {
            // verify required parameter 'jurisdictionId' is not null or undefined
            assertParamExists('enqueueSearch', 'jurisdictionId', jurisdictionId);
            // verify required parameter 'legacyEnqueueSearchRequestDto' is not null or undefined
            assertParamExists('enqueueSearch', 'legacyEnqueueSearchRequestDto', legacyEnqueueSearchRequestDto);
            const localVarPath = `/api/v2/immunizations/jurisdictions/{jurisdictionId}/search/enqueue`
                .replace(`{${"jurisdictionId"}}`, encodeURIComponent(String(jurisdictionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyToken required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-token", configuration);
            // authentication apiKeyEmail required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-email", configuration);
            // authentication docket-user required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(legacyEnqueueSearchRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevices: (xUserAgent_1, ...args_1) => __awaiter(this, [xUserAgent_1, ...args_1], void 0, function* (xUserAgent, options = {}) {
            const localVarPath = `/api/v2/device`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyToken required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-token", configuration);
            // authentication apiKeyEmail required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-email", configuration);
            // authentication docket-user required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} searchUid
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForecastReport: (jurisdictionId_1, searchUid_1, xUserAgent_1, ...args_1) => __awaiter(this, [jurisdictionId_1, searchUid_1, xUserAgent_1, ...args_1], void 0, function* (jurisdictionId, searchUid, xUserAgent, options = {}) {
            // verify required parameter 'jurisdictionId' is not null or undefined
            assertParamExists('getForecastReport', 'jurisdictionId', jurisdictionId);
            // verify required parameter 'searchUid' is not null or undefined
            assertParamExists('getForecastReport', 'searchUid', searchUid);
            const localVarPath = `/api/v2/immunizations/jurisdictions/{jurisdictionId}/forecast_report/{searchUid}`
                .replace(`{${"jurisdictionId"}}`, encodeURIComponent(String(jurisdictionId)))
                .replace(`{${"searchUid"}}`, encodeURIComponent(String(searchUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyToken required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-token", configuration);
            // authentication apiKeyEmail required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-email", configuration);
            // authentication docket-user required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} searchUid
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoryReport: (jurisdictionId_1, searchUid_1, xUserAgent_1, ...args_1) => __awaiter(this, [jurisdictionId_1, searchUid_1, xUserAgent_1, ...args_1], void 0, function* (jurisdictionId, searchUid, xUserAgent, options = {}) {
            // verify required parameter 'jurisdictionId' is not null or undefined
            assertParamExists('getHistoryReport', 'jurisdictionId', jurisdictionId);
            // verify required parameter 'searchUid' is not null or undefined
            assertParamExists('getHistoryReport', 'searchUid', searchUid);
            const localVarPath = `/api/v2/immunizations/jurisdictions/{jurisdictionId}/history_report/{searchUid}`
                .replace(`{${"jurisdictionId"}}`, encodeURIComponent(String(jurisdictionId)))
                .replace(`{${"searchUid"}}`, encodeURIComponent(String(searchUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyToken required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-token", configuration);
            // authentication apiKeyEmail required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-email", configuration);
            // authentication docket-user required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} jurisdictionId
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIncorrectContacts: (jurisdictionId_1, xUserAgent_1, ...args_1) => __awaiter(this, [jurisdictionId_1, xUserAgent_1, ...args_1], void 0, function* (jurisdictionId, xUserAgent, options = {}) {
            // verify required parameter 'jurisdictionId' is not null or undefined
            assertParamExists('getIncorrectContacts', 'jurisdictionId', jurisdictionId);
            const localVarPath = `/api/v2/immunizations/jurisdictions/{jurisdictionId}/incorrect_contacts`
                .replace(`{${"jurisdictionId"}}`, encodeURIComponent(String(jurisdictionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestRecords: (xUserAgent_1, ...args_1) => __awaiter(this, [xUserAgent_1, ...args_1], void 0, function* (xUserAgent, options = {}) {
            const localVarPath = `/api/v2/immunizations/latest_records`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyToken required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-token", configuration);
            // authentication apiKeyEmail required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-email", configuration);
            // authentication docket-user required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} searchUid
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonalImmunizationReport: (jurisdictionId_1, searchUid_1, xUserAgent_1, ...args_1) => __awaiter(this, [jurisdictionId_1, searchUid_1, xUserAgent_1, ...args_1], void 0, function* (jurisdictionId, searchUid, xUserAgent, options = {}) {
            // verify required parameter 'jurisdictionId' is not null or undefined
            assertParamExists('getPersonalImmunizationReport', 'jurisdictionId', jurisdictionId);
            // verify required parameter 'searchUid' is not null or undefined
            assertParamExists('getPersonalImmunizationReport', 'searchUid', searchUid);
            const localVarPath = `/api/v2/immunizations/jurisdictions/{jurisdictionId}/personal_report/{searchUid}`
                .replace(`{${"jurisdictionId"}}`, encodeURIComponent(String(jurisdictionId)))
                .replace(`{${"searchUid"}}`, encodeURIComponent(String(searchUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyToken required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-token", configuration);
            // authentication apiKeyEmail required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-email", configuration);
            // authentication docket-user required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderConfigs: (xUserAgent_1, ...args_1) => __awaiter(this, [xUserAgent_1, ...args_1], void 0, function* (xUserAgent, options = {}) {
            const localVarPath = `/api/v2/immunizations/provider/configs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyToken required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-token", configuration);
            // authentication apiKeyEmail required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-email", configuration);
            // authentication docket-user required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} searchUid
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecord: (jurisdictionId_1, searchUid_1, xUserAgent_1, ...args_1) => __awaiter(this, [jurisdictionId_1, searchUid_1, xUserAgent_1, ...args_1], void 0, function* (jurisdictionId, searchUid, xUserAgent, options = {}) {
            // verify required parameter 'jurisdictionId' is not null or undefined
            assertParamExists('getRecord', 'jurisdictionId', jurisdictionId);
            // verify required parameter 'searchUid' is not null or undefined
            assertParamExists('getRecord', 'searchUid', searchUid);
            const localVarPath = `/api/v2/immunizations/jurisdictions/{jurisdictionId}/records/{searchUid}`
                .replace(`{${"jurisdictionId"}}`, encodeURIComponent(String(jurisdictionId)))
                .replace(`{${"searchUid"}}`, encodeURIComponent(String(searchUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyToken required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-token", configuration);
            // authentication apiKeyEmail required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-email", configuration);
            // authentication docket-user required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecords: (xUserAgent_1, ...args_1) => __awaiter(this, [xUserAgent_1, ...args_1], void 0, function* (xUserAgent, options = {}) {
            const localVarPath = `/api/v2/immunizations/records`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyToken required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-token", configuration);
            // authentication apiKeyEmail required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-email", configuration);
            // authentication docket-user required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} searchUid
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchoolReport: (jurisdictionId_1, searchUid_1, xUserAgent_1, ...args_1) => __awaiter(this, [jurisdictionId_1, searchUid_1, xUserAgent_1, ...args_1], void 0, function* (jurisdictionId, searchUid, xUserAgent, options = {}) {
            // verify required parameter 'jurisdictionId' is not null or undefined
            assertParamExists('getSchoolReport', 'jurisdictionId', jurisdictionId);
            // verify required parameter 'searchUid' is not null or undefined
            assertParamExists('getSchoolReport', 'searchUid', searchUid);
            const localVarPath = `/api/v2/immunizations/jurisdictions/{jurisdictionId}/school_report/{searchUid}`
                .replace(`{${"jurisdictionId"}}`, encodeURIComponent(String(jurisdictionId)))
                .replace(`{${"searchUid"}}`, encodeURIComponent(String(searchUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyToken required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-token", configuration);
            // authentication apiKeyEmail required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-email", configuration);
            // authentication docket-user required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} searchUid
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScreenings: (jurisdictionId_1, searchUid_1, xUserAgent_1, ...args_1) => __awaiter(this, [jurisdictionId_1, searchUid_1, xUserAgent_1, ...args_1], void 0, function* (jurisdictionId, searchUid, xUserAgent, options = {}) {
            // verify required parameter 'jurisdictionId' is not null or undefined
            assertParamExists('getScreenings', 'jurisdictionId', jurisdictionId);
            // verify required parameter 'searchUid' is not null or undefined
            assertParamExists('getScreenings', 'searchUid', searchUid);
            const localVarPath = `/api/v2/immunizations/jurisdictions/{jurisdictionId}/records/{searchUid}/screenings`
                .replace(`{${"jurisdictionId"}}`, encodeURIComponent(String(jurisdictionId)))
                .replace(`{${"searchUid"}}`, encodeURIComponent(String(searchUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyToken required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-token", configuration);
            // authentication apiKeyEmail required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-email", configuration);
            // authentication docket-user required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} searchUid
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearch: (jurisdictionId_1, searchUid_1, xUserAgent_1, ...args_1) => __awaiter(this, [jurisdictionId_1, searchUid_1, xUserAgent_1, ...args_1], void 0, function* (jurisdictionId, searchUid, xUserAgent, options = {}) {
            // verify required parameter 'jurisdictionId' is not null or undefined
            assertParamExists('getSearch', 'jurisdictionId', jurisdictionId);
            // verify required parameter 'searchUid' is not null or undefined
            assertParamExists('getSearch', 'searchUid', searchUid);
            const localVarPath = `/api/v2/immunizations/jurisdictions/{jurisdictionId}/search/{searchUid}`
                .replace(`{${"jurisdictionId"}}`, encodeURIComponent(String(jurisdictionId)))
                .replace(`{${"searchUid"}}`, encodeURIComponent(String(searchUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyToken required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-token", configuration);
            // authentication apiKeyEmail required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-email", configuration);
            // authentication docket-user required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tapped
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearches: (tapped_1, xUserAgent_1, ...args_1) => __awaiter(this, [tapped_1, xUserAgent_1, ...args_1], void 0, function* (tapped, xUserAgent, options = {}) {
            // verify required parameter 'tapped' is not null or undefined
            assertParamExists('getSearches', 'tapped', tapped);
            const localVarPath = `/api/v2/immunizations/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyToken required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-token", configuration);
            // authentication apiKeyEmail required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-email", configuration);
            // authentication docket-user required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (tapped !== undefined) {
                localVarQueryParameter['tapped'] = tapped;
            }
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: (xUserAgent_1, ...args_1) => __awaiter(this, [xUserAgent_1, ...args_1], void 0, function* (xUserAgent, options = {}) {
            const localVarPath = `/api/v2/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyToken required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-token", configuration);
            // authentication apiKeyEmail required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-email", configuration);
            // authentication docket-user required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} recordUid
         * @param {string} vaccineType
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVaccineCard: (jurisdictionId_1, recordUid_1, vaccineType_1, xUserAgent_1, ...args_1) => __awaiter(this, [jurisdictionId_1, recordUid_1, vaccineType_1, xUserAgent_1, ...args_1], void 0, function* (jurisdictionId, recordUid, vaccineType, xUserAgent, options = {}) {
            // verify required parameter 'jurisdictionId' is not null or undefined
            assertParamExists('getVaccineCard', 'jurisdictionId', jurisdictionId);
            // verify required parameter 'recordUid' is not null or undefined
            assertParamExists('getVaccineCard', 'recordUid', recordUid);
            // verify required parameter 'vaccineType' is not null or undefined
            assertParamExists('getVaccineCard', 'vaccineType', vaccineType);
            const localVarPath = `/api/v2/immunizations/jurisdictions/{jurisdictionId}/smartcard/vaccine/{recordUid}/{vaccineType}`
                .replace(`{${"jurisdictionId"}}`, encodeURIComponent(String(jurisdictionId)))
                .replace(`{${"recordUid"}}`, encodeURIComponent(String(recordUid)))
                .replace(`{${"vaccineType"}}`, encodeURIComponent(String(vaccineType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyToken required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-token", configuration);
            // authentication apiKeyEmail required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-email", configuration);
            // authentication docket-user required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshRecordsAsync: (xUserAgent_1, ...args_1) => __awaiter(this, [xUserAgent_1, ...args_1], void 0, function* (xUserAgent, options = {}) {
            const localVarPath = `/api/v2/immunizations/refresh_records_async`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyToken required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-token", configuration);
            // authentication apiKeyEmail required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-email", configuration);
            // authentication docket-user required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} searchUid
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshSearch: (jurisdictionId_1, searchUid_1, xUserAgent_1, ...args_1) => __awaiter(this, [jurisdictionId_1, searchUid_1, xUserAgent_1, ...args_1], void 0, function* (jurisdictionId, searchUid, xUserAgent, options = {}) {
            // verify required parameter 'jurisdictionId' is not null or undefined
            assertParamExists('refreshSearch', 'jurisdictionId', jurisdictionId);
            // verify required parameter 'searchUid' is not null or undefined
            assertParamExists('refreshSearch', 'searchUid', searchUid);
            const localVarPath = `/api/v2/immunizations/jurisdictions/{jurisdictionId}/refresh_search/{searchUid}`
                .replace(`{${"jurisdictionId"}}`, encodeURIComponent(String(jurisdictionId)))
                .replace(`{${"searchUid"}}`, encodeURIComponent(String(searchUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyToken required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-token", configuration);
            // authentication apiKeyEmail required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-email", configuration);
            // authentication docket-user required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testNotification: (xUserAgent_1, ...args_1) => __awaiter(this, [xUserAgent_1, ...args_1], void 0, function* (xUserAgent, options = {}) {
            const localVarPath = `/api/v2/device/test_notification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyToken required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-token", configuration);
            // authentication apiKeyEmail required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-email", configuration);
            // authentication docket-user required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {LegacyUpdateUserRequestDto} legacyUpdateUserRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: (legacyUpdateUserRequestDto_1, xUserAgent_1, ...args_1) => __awaiter(this, [legacyUpdateUserRequestDto_1, xUserAgent_1, ...args_1], void 0, function* (legacyUpdateUserRequestDto, xUserAgent, options = {}) {
            // verify required parameter 'legacyUpdateUserRequestDto' is not null or undefined
            assertParamExists('updateUser', 'legacyUpdateUserRequestDto', legacyUpdateUserRequestDto);
            const localVarPath = `/api/v2/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyToken required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-token", configuration);
            // authentication apiKeyEmail required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-email", configuration);
            // authentication docket-user required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(legacyUpdateUserRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} searchUid
         * @param {LegacyVerifySearchPinRequestDto} legacyVerifySearchPinRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifySearchPin: (jurisdictionId_1, searchUid_1, legacyVerifySearchPinRequestDto_1, xUserAgent_1, ...args_1) => __awaiter(this, [jurisdictionId_1, searchUid_1, legacyVerifySearchPinRequestDto_1, xUserAgent_1, ...args_1], void 0, function* (jurisdictionId, searchUid, legacyVerifySearchPinRequestDto, xUserAgent, options = {}) {
            // verify required parameter 'jurisdictionId' is not null or undefined
            assertParamExists('verifySearchPin', 'jurisdictionId', jurisdictionId);
            // verify required parameter 'searchUid' is not null or undefined
            assertParamExists('verifySearchPin', 'searchUid', searchUid);
            // verify required parameter 'legacyVerifySearchPinRequestDto' is not null or undefined
            assertParamExists('verifySearchPin', 'legacyVerifySearchPinRequestDto', legacyVerifySearchPinRequestDto);
            const localVarPath = `/api/v2/immunizations/jurisdictions/{jurisdictionId}/verify_pin/{searchUid}`
                .replace(`{${"jurisdictionId"}}`, encodeURIComponent(String(jurisdictionId)))
                .replace(`{${"searchUid"}}`, encodeURIComponent(String(searchUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyToken required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-token", configuration);
            // authentication apiKeyEmail required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-email", configuration);
            // authentication docket-user required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(legacyVerifySearchPinRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {LegacyVerifyUserPhoneRequestDto} legacyVerifyUserPhoneRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyUserPhone: (legacyVerifyUserPhoneRequestDto_1, xUserAgent_1, ...args_1) => __awaiter(this, [legacyVerifyUserPhoneRequestDto_1, xUserAgent_1, ...args_1], void 0, function* (legacyVerifyUserPhoneRequestDto, xUserAgent, options = {}) {
            // verify required parameter 'legacyVerifyUserPhoneRequestDto' is not null or undefined
            assertParamExists('verifyUserPhone', 'legacyVerifyUserPhoneRequestDto', legacyVerifyUserPhoneRequestDto);
            const localVarPath = `/api/v2/user/verify_phone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyToken required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-token", configuration);
            // authentication apiKeyEmail required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-email", configuration);
            // authentication docket-user required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(legacyVerifyUserPhoneRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {LegacyVerifyUserPhoneCodeRequestDto} legacyVerifyUserPhoneCodeRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyUserPhoneCode: (legacyVerifyUserPhoneCodeRequestDto_1, xUserAgent_1, ...args_1) => __awaiter(this, [legacyVerifyUserPhoneCodeRequestDto_1, xUserAgent_1, ...args_1], void 0, function* (legacyVerifyUserPhoneCodeRequestDto, xUserAgent, options = {}) {
            // verify required parameter 'legacyVerifyUserPhoneCodeRequestDto' is not null or undefined
            assertParamExists('verifyUserPhoneCode', 'legacyVerifyUserPhoneCodeRequestDto', legacyVerifyUserPhoneCodeRequestDto);
            const localVarPath = `/api/v2/user/verify_phone_code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyToken required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-token", configuration);
            // authentication apiKeyEmail required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-email", configuration);
            // authentication docket-user required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(legacyVerifyUserPhoneCodeRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * RailsLegacyV2Api - functional programming interface
 * @export
 */
export const RailsLegacyV2ApiFp = function (configuration) {
    const localVarAxiosParamCreator = RailsLegacyV2ApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {LegacyCreateDeviceRequestDto} legacyCreateDeviceRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDevice(legacyCreateDeviceRequestDto, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createDevice(legacyCreateDeviceRequestDto, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RailsLegacyV2Api.createDevice']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} deviceId
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDevice(deviceId, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteDevice(deviceId, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RailsLegacyV2Api.deleteDevice']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} searchUid
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRecord(jurisdictionId, searchUid, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteRecord(jurisdictionId, searchUid, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RailsLegacyV2Api.deleteRecord']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} searchUid
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSearch(jurisdictionId, searchUid, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteSearch(jurisdictionId, searchUid, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RailsLegacyV2Api.deleteSearch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteUser(xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RailsLegacyV2Api.deleteUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} searchUid
         * @param {LegacyDeliverSearchPinRequestDto} legacyDeliverSearchPinRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliverSearchPin(jurisdictionId, searchUid, legacyDeliverSearchPinRequestDto, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deliverSearchPin(jurisdictionId, searchUid, legacyDeliverSearchPinRequestDto, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RailsLegacyV2Api.deliverSearchPin']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} jurisdictionId
         * @param {LegacyEnqueueSearchRequestDto} legacyEnqueueSearchRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enqueueSearch(jurisdictionId, legacyEnqueueSearchRequestDto, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.enqueueSearch(jurisdictionId, legacyEnqueueSearchRequestDto, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RailsLegacyV2Api.enqueueSearch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevices(xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDevices(xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RailsLegacyV2Api.getDevices']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} searchUid
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForecastReport(jurisdictionId, searchUid, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getForecastReport(jurisdictionId, searchUid, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RailsLegacyV2Api.getForecastReport']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} searchUid
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoryReport(jurisdictionId, searchUid, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getHistoryReport(jurisdictionId, searchUid, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RailsLegacyV2Api.getHistoryReport']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} jurisdictionId
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIncorrectContacts(jurisdictionId, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getIncorrectContacts(jurisdictionId, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RailsLegacyV2Api.getIncorrectContacts']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestRecords(xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLatestRecords(xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RailsLegacyV2Api.getLatestRecords']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} searchUid
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonalImmunizationReport(jurisdictionId, searchUid, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPersonalImmunizationReport(jurisdictionId, searchUid, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RailsLegacyV2Api.getPersonalImmunizationReport']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderConfigs(xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProviderConfigs(xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RailsLegacyV2Api.getProviderConfigs']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} searchUid
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecord(jurisdictionId, searchUid, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRecord(jurisdictionId, searchUid, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RailsLegacyV2Api.getRecord']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecords(xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRecords(xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RailsLegacyV2Api.getRecords']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} searchUid
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchoolReport(jurisdictionId, searchUid, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSchoolReport(jurisdictionId, searchUid, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RailsLegacyV2Api.getSchoolReport']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} searchUid
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScreenings(jurisdictionId, searchUid, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getScreenings(jurisdictionId, searchUid, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RailsLegacyV2Api.getScreenings']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} searchUid
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearch(jurisdictionId, searchUid, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSearch(jurisdictionId, searchUid, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RailsLegacyV2Api.getSearch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} tapped
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearches(tapped, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSearches(tapped, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RailsLegacyV2Api.getSearches']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser(xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUser(xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RailsLegacyV2Api.getUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} recordUid
         * @param {string} vaccineType
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVaccineCard(jurisdictionId, recordUid, vaccineType, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getVaccineCard(jurisdictionId, recordUid, vaccineType, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RailsLegacyV2Api.getVaccineCard']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshRecordsAsync(xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.refreshRecordsAsync(xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RailsLegacyV2Api.refreshRecordsAsync']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} searchUid
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshSearch(jurisdictionId, searchUid, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.refreshSearch(jurisdictionId, searchUid, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RailsLegacyV2Api.refreshSearch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testNotification(xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.testNotification(xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RailsLegacyV2Api.testNotification']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {LegacyUpdateUserRequestDto} legacyUpdateUserRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(legacyUpdateUserRequestDto, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateUser(legacyUpdateUserRequestDto, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RailsLegacyV2Api.updateUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} searchUid
         * @param {LegacyVerifySearchPinRequestDto} legacyVerifySearchPinRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifySearchPin(jurisdictionId, searchUid, legacyVerifySearchPinRequestDto, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.verifySearchPin(jurisdictionId, searchUid, legacyVerifySearchPinRequestDto, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RailsLegacyV2Api.verifySearchPin']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {LegacyVerifyUserPhoneRequestDto} legacyVerifyUserPhoneRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyUserPhone(legacyVerifyUserPhoneRequestDto, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.verifyUserPhone(legacyVerifyUserPhoneRequestDto, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RailsLegacyV2Api.verifyUserPhone']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {LegacyVerifyUserPhoneCodeRequestDto} legacyVerifyUserPhoneCodeRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyUserPhoneCode(legacyVerifyUserPhoneCodeRequestDto, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.verifyUserPhoneCode(legacyVerifyUserPhoneCodeRequestDto, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RailsLegacyV2Api.verifyUserPhoneCode']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * RailsLegacyV2Api - factory interface
 * @export
 */
export const RailsLegacyV2ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RailsLegacyV2ApiFp(configuration);
    return {
        /**
         *
         * @param {LegacyCreateDeviceRequestDto} legacyCreateDeviceRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDevice(legacyCreateDeviceRequestDto, xUserAgent, options) {
            return localVarFp.createDevice(legacyCreateDeviceRequestDto, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} deviceId
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDevice(deviceId, xUserAgent, options) {
            return localVarFp.deleteDevice(deviceId, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} searchUid
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRecord(jurisdictionId, searchUid, xUserAgent, options) {
            return localVarFp.deleteRecord(jurisdictionId, searchUid, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} searchUid
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSearch(jurisdictionId, searchUid, xUserAgent, options) {
            return localVarFp.deleteSearch(jurisdictionId, searchUid, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(xUserAgent, options) {
            return localVarFp.deleteUser(xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} searchUid
         * @param {LegacyDeliverSearchPinRequestDto} legacyDeliverSearchPinRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliverSearchPin(jurisdictionId, searchUid, legacyDeliverSearchPinRequestDto, xUserAgent, options) {
            return localVarFp.deliverSearchPin(jurisdictionId, searchUid, legacyDeliverSearchPinRequestDto, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} jurisdictionId
         * @param {LegacyEnqueueSearchRequestDto} legacyEnqueueSearchRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enqueueSearch(jurisdictionId, legacyEnqueueSearchRequestDto, xUserAgent, options) {
            return localVarFp.enqueueSearch(jurisdictionId, legacyEnqueueSearchRequestDto, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevices(xUserAgent, options) {
            return localVarFp.getDevices(xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} searchUid
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForecastReport(jurisdictionId, searchUid, xUserAgent, options) {
            return localVarFp.getForecastReport(jurisdictionId, searchUid, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} searchUid
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoryReport(jurisdictionId, searchUid, xUserAgent, options) {
            return localVarFp.getHistoryReport(jurisdictionId, searchUid, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} jurisdictionId
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIncorrectContacts(jurisdictionId, xUserAgent, options) {
            return localVarFp.getIncorrectContacts(jurisdictionId, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestRecords(xUserAgent, options) {
            return localVarFp.getLatestRecords(xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} searchUid
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonalImmunizationReport(jurisdictionId, searchUid, xUserAgent, options) {
            return localVarFp.getPersonalImmunizationReport(jurisdictionId, searchUid, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderConfigs(xUserAgent, options) {
            return localVarFp.getProviderConfigs(xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} searchUid
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecord(jurisdictionId, searchUid, xUserAgent, options) {
            return localVarFp.getRecord(jurisdictionId, searchUid, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecords(xUserAgent, options) {
            return localVarFp.getRecords(xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} searchUid
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchoolReport(jurisdictionId, searchUid, xUserAgent, options) {
            return localVarFp.getSchoolReport(jurisdictionId, searchUid, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} searchUid
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScreenings(jurisdictionId, searchUid, xUserAgent, options) {
            return localVarFp.getScreenings(jurisdictionId, searchUid, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} searchUid
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearch(jurisdictionId, searchUid, xUserAgent, options) {
            return localVarFp.getSearch(jurisdictionId, searchUid, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} tapped
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearches(tapped, xUserAgent, options) {
            return localVarFp.getSearches(tapped, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser(xUserAgent, options) {
            return localVarFp.getUser(xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} recordUid
         * @param {string} vaccineType
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVaccineCard(jurisdictionId, recordUid, vaccineType, xUserAgent, options) {
            return localVarFp.getVaccineCard(jurisdictionId, recordUid, vaccineType, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshRecordsAsync(xUserAgent, options) {
            return localVarFp.refreshRecordsAsync(xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} searchUid
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshSearch(jurisdictionId, searchUid, xUserAgent, options) {
            return localVarFp.refreshSearch(jurisdictionId, searchUid, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testNotification(xUserAgent, options) {
            return localVarFp.testNotification(xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {LegacyUpdateUserRequestDto} legacyUpdateUserRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(legacyUpdateUserRequestDto, xUserAgent, options) {
            return localVarFp.updateUser(legacyUpdateUserRequestDto, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} jurisdictionId
         * @param {string} searchUid
         * @param {LegacyVerifySearchPinRequestDto} legacyVerifySearchPinRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifySearchPin(jurisdictionId, searchUid, legacyVerifySearchPinRequestDto, xUserAgent, options) {
            return localVarFp.verifySearchPin(jurisdictionId, searchUid, legacyVerifySearchPinRequestDto, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {LegacyVerifyUserPhoneRequestDto} legacyVerifyUserPhoneRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyUserPhone(legacyVerifyUserPhoneRequestDto, xUserAgent, options) {
            return localVarFp.verifyUserPhone(legacyVerifyUserPhoneRequestDto, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {LegacyVerifyUserPhoneCodeRequestDto} legacyVerifyUserPhoneCodeRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyUserPhoneCode(legacyVerifyUserPhoneCodeRequestDto, xUserAgent, options) {
            return localVarFp.verifyUserPhoneCode(legacyVerifyUserPhoneCodeRequestDto, xUserAgent, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * RailsLegacyV2Api - object-oriented interface
 * @export
 * @class RailsLegacyV2Api
 * @extends {BaseAPI}
 */
export class RailsLegacyV2Api extends BaseAPI {
    /**
     *
     * @param {LegacyCreateDeviceRequestDto} legacyCreateDeviceRequestDto
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RailsLegacyV2Api
     */
    createDevice(legacyCreateDeviceRequestDto, xUserAgent, options) {
        return RailsLegacyV2ApiFp(this.configuration).createDevice(legacyCreateDeviceRequestDto, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} deviceId
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RailsLegacyV2Api
     */
    deleteDevice(deviceId, xUserAgent, options) {
        return RailsLegacyV2ApiFp(this.configuration).deleteDevice(deviceId, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} jurisdictionId
     * @param {string} searchUid
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RailsLegacyV2Api
     */
    deleteRecord(jurisdictionId, searchUid, xUserAgent, options) {
        return RailsLegacyV2ApiFp(this.configuration).deleteRecord(jurisdictionId, searchUid, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} jurisdictionId
     * @param {string} searchUid
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RailsLegacyV2Api
     */
    deleteSearch(jurisdictionId, searchUid, xUserAgent, options) {
        return RailsLegacyV2ApiFp(this.configuration).deleteSearch(jurisdictionId, searchUid, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RailsLegacyV2Api
     */
    deleteUser(xUserAgent, options) {
        return RailsLegacyV2ApiFp(this.configuration).deleteUser(xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} jurisdictionId
     * @param {string} searchUid
     * @param {LegacyDeliverSearchPinRequestDto} legacyDeliverSearchPinRequestDto
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RailsLegacyV2Api
     */
    deliverSearchPin(jurisdictionId, searchUid, legacyDeliverSearchPinRequestDto, xUserAgent, options) {
        return RailsLegacyV2ApiFp(this.configuration).deliverSearchPin(jurisdictionId, searchUid, legacyDeliverSearchPinRequestDto, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} jurisdictionId
     * @param {LegacyEnqueueSearchRequestDto} legacyEnqueueSearchRequestDto
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RailsLegacyV2Api
     */
    enqueueSearch(jurisdictionId, legacyEnqueueSearchRequestDto, xUserAgent, options) {
        return RailsLegacyV2ApiFp(this.configuration).enqueueSearch(jurisdictionId, legacyEnqueueSearchRequestDto, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RailsLegacyV2Api
     */
    getDevices(xUserAgent, options) {
        return RailsLegacyV2ApiFp(this.configuration).getDevices(xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} jurisdictionId
     * @param {string} searchUid
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RailsLegacyV2Api
     */
    getForecastReport(jurisdictionId, searchUid, xUserAgent, options) {
        return RailsLegacyV2ApiFp(this.configuration).getForecastReport(jurisdictionId, searchUid, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} jurisdictionId
     * @param {string} searchUid
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RailsLegacyV2Api
     */
    getHistoryReport(jurisdictionId, searchUid, xUserAgent, options) {
        return RailsLegacyV2ApiFp(this.configuration).getHistoryReport(jurisdictionId, searchUid, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} jurisdictionId
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RailsLegacyV2Api
     */
    getIncorrectContacts(jurisdictionId, xUserAgent, options) {
        return RailsLegacyV2ApiFp(this.configuration).getIncorrectContacts(jurisdictionId, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RailsLegacyV2Api
     */
    getLatestRecords(xUserAgent, options) {
        return RailsLegacyV2ApiFp(this.configuration).getLatestRecords(xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} jurisdictionId
     * @param {string} searchUid
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RailsLegacyV2Api
     */
    getPersonalImmunizationReport(jurisdictionId, searchUid, xUserAgent, options) {
        return RailsLegacyV2ApiFp(this.configuration).getPersonalImmunizationReport(jurisdictionId, searchUid, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RailsLegacyV2Api
     */
    getProviderConfigs(xUserAgent, options) {
        return RailsLegacyV2ApiFp(this.configuration).getProviderConfigs(xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} jurisdictionId
     * @param {string} searchUid
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RailsLegacyV2Api
     */
    getRecord(jurisdictionId, searchUid, xUserAgent, options) {
        return RailsLegacyV2ApiFp(this.configuration).getRecord(jurisdictionId, searchUid, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RailsLegacyV2Api
     */
    getRecords(xUserAgent, options) {
        return RailsLegacyV2ApiFp(this.configuration).getRecords(xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} jurisdictionId
     * @param {string} searchUid
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RailsLegacyV2Api
     */
    getSchoolReport(jurisdictionId, searchUid, xUserAgent, options) {
        return RailsLegacyV2ApiFp(this.configuration).getSchoolReport(jurisdictionId, searchUid, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} jurisdictionId
     * @param {string} searchUid
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RailsLegacyV2Api
     */
    getScreenings(jurisdictionId, searchUid, xUserAgent, options) {
        return RailsLegacyV2ApiFp(this.configuration).getScreenings(jurisdictionId, searchUid, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} jurisdictionId
     * @param {string} searchUid
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RailsLegacyV2Api
     */
    getSearch(jurisdictionId, searchUid, xUserAgent, options) {
        return RailsLegacyV2ApiFp(this.configuration).getSearch(jurisdictionId, searchUid, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} tapped
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RailsLegacyV2Api
     */
    getSearches(tapped, xUserAgent, options) {
        return RailsLegacyV2ApiFp(this.configuration).getSearches(tapped, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RailsLegacyV2Api
     */
    getUser(xUserAgent, options) {
        return RailsLegacyV2ApiFp(this.configuration).getUser(xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} jurisdictionId
     * @param {string} recordUid
     * @param {string} vaccineType
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RailsLegacyV2Api
     */
    getVaccineCard(jurisdictionId, recordUid, vaccineType, xUserAgent, options) {
        return RailsLegacyV2ApiFp(this.configuration).getVaccineCard(jurisdictionId, recordUid, vaccineType, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RailsLegacyV2Api
     */
    refreshRecordsAsync(xUserAgent, options) {
        return RailsLegacyV2ApiFp(this.configuration).refreshRecordsAsync(xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} jurisdictionId
     * @param {string} searchUid
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RailsLegacyV2Api
     */
    refreshSearch(jurisdictionId, searchUid, xUserAgent, options) {
        return RailsLegacyV2ApiFp(this.configuration).refreshSearch(jurisdictionId, searchUid, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RailsLegacyV2Api
     */
    testNotification(xUserAgent, options) {
        return RailsLegacyV2ApiFp(this.configuration).testNotification(xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LegacyUpdateUserRequestDto} legacyUpdateUserRequestDto
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RailsLegacyV2Api
     */
    updateUser(legacyUpdateUserRequestDto, xUserAgent, options) {
        return RailsLegacyV2ApiFp(this.configuration).updateUser(legacyUpdateUserRequestDto, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} jurisdictionId
     * @param {string} searchUid
     * @param {LegacyVerifySearchPinRequestDto} legacyVerifySearchPinRequestDto
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RailsLegacyV2Api
     */
    verifySearchPin(jurisdictionId, searchUid, legacyVerifySearchPinRequestDto, xUserAgent, options) {
        return RailsLegacyV2ApiFp(this.configuration).verifySearchPin(jurisdictionId, searchUid, legacyVerifySearchPinRequestDto, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LegacyVerifyUserPhoneRequestDto} legacyVerifyUserPhoneRequestDto
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RailsLegacyV2Api
     */
    verifyUserPhone(legacyVerifyUserPhoneRequestDto, xUserAgent, options) {
        return RailsLegacyV2ApiFp(this.configuration).verifyUserPhone(legacyVerifyUserPhoneRequestDto, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LegacyVerifyUserPhoneCodeRequestDto} legacyVerifyUserPhoneCodeRequestDto
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RailsLegacyV2Api
     */
    verifyUserPhoneCode(legacyVerifyUserPhoneCodeRequestDto, xUserAgent, options) {
        return RailsLegacyV2ApiFp(this.configuration).verifyUserPhoneCode(legacyVerifyUserPhoneCodeRequestDto, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SmartHealthLinksApi - axios parameter creator
 * @export
 */
export const SmartHealthLinksApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShlink: (id_1, xUserAgent_1, ...args_1) => __awaiter(this, [id_1, xUserAgent_1, ...args_1], void 0, function* (id, xUserAgent, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getShlink', 'id', id);
            const localVarPath = `/api/smarthealth/link/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyToken required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-token", configuration);
            // authentication apiKeyEmail required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-email", configuration);
            // authentication docket-user required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShlinkAccessLogs: (id_1, limit_1, offset_1, xUserAgent_1, ...args_1) => __awaiter(this, [id_1, limit_1, offset_1, xUserAgent_1, ...args_1], void 0, function* (id, limit, offset, xUserAgent, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getShlinkAccessLogs', 'id', id);
            const localVarPath = `/api/smarthealth/link/{id}/access_log`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyToken required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-token", configuration);
            // authentication apiKeyEmail required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-email", configuration);
            // authentication docket-user required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShlinks: (limit_1, offset_1, xUserAgent_1, ...args_1) => __awaiter(this, [limit_1, offset_1, xUserAgent_1, ...args_1], void 0, function* (limit, offset, xUserAgent, options = {}) {
            const localVarPath = `/api/smarthealth/link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyToken required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-token", configuration);
            // authentication apiKeyEmail required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-email", configuration);
            // authentication docket-user required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} manifestId
         * @param {ManifestRequestDto} manifestRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postManifest: (manifestId_1, manifestRequestDto_1, xUserAgent_1, ...args_1) => __awaiter(this, [manifestId_1, manifestRequestDto_1, xUserAgent_1, ...args_1], void 0, function* (manifestId, manifestRequestDto, xUserAgent, options = {}) {
            // verify required parameter 'manifestId' is not null or undefined
            assertParamExists('postManifest', 'manifestId', manifestId);
            // verify required parameter 'manifestRequestDto' is not null or undefined
            assertParamExists('postManifest', 'manifestRequestDto', manifestRequestDto);
            const localVarPath = `/api/smarthealth/link/{manifestId}`
                .replace(`{${"manifestId"}}`, encodeURIComponent(String(manifestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(manifestRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateSHLinkDto} createSHLinkDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postShlink: (createSHLinkDto_1, xUserAgent_1, ...args_1) => __awaiter(this, [createSHLinkDto_1, xUserAgent_1, ...args_1], void 0, function* (createSHLinkDto, xUserAgent, options = {}) {
            // verify required parameter 'createSHLinkDto' is not null or undefined
            assertParamExists('postShlink', 'createSHLinkDto', createSHLinkDto);
            const localVarPath = `/api/smarthealth/link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyToken required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-token", configuration);
            // authentication apiKeyEmail required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-email", configuration);
            // authentication docket-user required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createSHLinkDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {UpdateSHLinkDto} updateSHLinkDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShlink: (id_1, updateSHLinkDto_1, xUserAgent_1, ...args_1) => __awaiter(this, [id_1, updateSHLinkDto_1, xUserAgent_1, ...args_1], void 0, function* (id, updateSHLinkDto, xUserAgent, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateShlink', 'id', id);
            // verify required parameter 'updateSHLinkDto' is not null or undefined
            assertParamExists('updateShlink', 'updateSHLinkDto', updateSHLinkDto);
            const localVarPath = `/api/smarthealth/link/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyToken required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-token", configuration);
            // authentication apiKeyEmail required
            yield setApiKeyToObject(localVarHeaderParameter, "x-user-email", configuration);
            // authentication docket-user required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = typeof xUserAgent === 'string'
                    ? xUserAgent
                    : JSON.stringify(xUserAgent);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateSHLinkDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * SmartHealthLinksApi - functional programming interface
 * @export
 */
export const SmartHealthLinksApiFp = function (configuration) {
    const localVarAxiosParamCreator = SmartHealthLinksApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShlink(id, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getShlink(id, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SmartHealthLinksApi.getShlink']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} id
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShlinkAccessLogs(id, limit, offset, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getShlinkAccessLogs(id, limit, offset, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SmartHealthLinksApi.getShlinkAccessLogs']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShlinks(limit, offset, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getShlinks(limit, offset, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SmartHealthLinksApi.getShlinks']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} manifestId
         * @param {ManifestRequestDto} manifestRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postManifest(manifestId, manifestRequestDto, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.postManifest(manifestId, manifestRequestDto, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SmartHealthLinksApi.postManifest']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {CreateSHLinkDto} createSHLinkDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postShlink(createSHLinkDto, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.postShlink(createSHLinkDto, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SmartHealthLinksApi.postShlink']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} id
         * @param {UpdateSHLinkDto} updateSHLinkDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShlink(id, updateSHLinkDto, xUserAgent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateShlink(id, updateSHLinkDto, xUserAgent, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SmartHealthLinksApi.updateShlink']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * SmartHealthLinksApi - factory interface
 * @export
 */
export const SmartHealthLinksApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SmartHealthLinksApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShlink(id, xUserAgent, options) {
            return localVarFp.getShlink(id, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShlinkAccessLogs(id, limit, offset, xUserAgent, options) {
            return localVarFp.getShlinkAccessLogs(id, limit, offset, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShlinks(limit, offset, xUserAgent, options) {
            return localVarFp.getShlinks(limit, offset, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} manifestId
         * @param {ManifestRequestDto} manifestRequestDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postManifest(manifestId, manifestRequestDto, xUserAgent, options) {
            return localVarFp.postManifest(manifestId, manifestRequestDto, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateSHLinkDto} createSHLinkDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postShlink(createSHLinkDto, xUserAgent, options) {
            return localVarFp.postShlink(createSHLinkDto, xUserAgent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateSHLinkDto} updateSHLinkDto
         * @param {any} [xUserAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShlink(id, updateSHLinkDto, xUserAgent, options) {
            return localVarFp.updateShlink(id, updateSHLinkDto, xUserAgent, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SmartHealthLinksApi - object-oriented interface
 * @export
 * @class SmartHealthLinksApi
 * @extends {BaseAPI}
 */
export class SmartHealthLinksApi extends BaseAPI {
    /**
     *
     * @param {string} id
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmartHealthLinksApi
     */
    getShlink(id, xUserAgent, options) {
        return SmartHealthLinksApiFp(this.configuration).getShlink(id, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} id
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmartHealthLinksApi
     */
    getShlinkAccessLogs(id, limit, offset, xUserAgent, options) {
        return SmartHealthLinksApiFp(this.configuration).getShlinkAccessLogs(id, limit, offset, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmartHealthLinksApi
     */
    getShlinks(limit, offset, xUserAgent, options) {
        return SmartHealthLinksApiFp(this.configuration).getShlinks(limit, offset, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} manifestId
     * @param {ManifestRequestDto} manifestRequestDto
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmartHealthLinksApi
     */
    postManifest(manifestId, manifestRequestDto, xUserAgent, options) {
        return SmartHealthLinksApiFp(this.configuration).postManifest(manifestId, manifestRequestDto, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CreateSHLinkDto} createSHLinkDto
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmartHealthLinksApi
     */
    postShlink(createSHLinkDto, xUserAgent, options) {
        return SmartHealthLinksApiFp(this.configuration).postShlink(createSHLinkDto, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} id
     * @param {UpdateSHLinkDto} updateSHLinkDto
     * @param {any} [xUserAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmartHealthLinksApi
     */
    updateShlink(id, updateSHLinkDto, xUserAgent, options) {
        return SmartHealthLinksApiFp(this.configuration).updateShlink(id, updateSHLinkDto, xUserAgent, options).then((request) => request(this.axios, this.basePath));
    }
}
